"use client";

import { Button } from "antd";
import BreadcrumbComp from "../shared/BreadcrumbComp";
import Link from "next/link";

const breadcrumbs = [
  { title: "Trang Chủ", href: "/" },
  { title: "Dịch vụ", href: "/dich-vu" },
];

function ServiceIndex({ services, setting }) {
  const aboutUs = JSON.parse(setting?.aboutUs || "{}");

  return (
    <div className="overflow-hidden">
      <div className="section mx-auto px-4">
        <div>
          <BreadcrumbComp items={breadcrumbs} />
          <h1
            className="text-center text-3xl md:text-5xl xl:text-6xl font-bold my-6 md:my-10"
            data-aos="fade-down"
          >
            Dịch vụ
          </h1>
        </div>
      </div>

      <div>
        {services.map((item, index) => {
          const isEven = index % 2 === 0;

          if (isEven) {
            return (
              <div
                id={item.slug}
                className="bg-[#0C1B56] relative overflow-hidden"
              >
                <div className="container py-12 md:py-20 xl:!py-[150px] flex flex-col lg:flex-row gap-6 md:gap-12 xl:gap-[107px] items-center lg:items-end px-4 xl:px-0">
                  <div
                    className="w-full lg:w-auto lg:flex-shrink-0 rounded-sm shadow-md"
                    data-aos="fade-right"
                  >
                    <img
                      src={item.thumbnail}
                      alt={item.name}
                      className="w-full h-[250px] md:h-[400px] xl:h-[560px] max-w-[650px] object-cover !rounded-lg lg:rounded-none"
                    />
                  </div>

                  <div data-aos="fade-left">
                    <p className="italic text-6xl md:text-[120px] xl:text-[200px] font-[900] text-[#007AFF] leading-none mb-4 md:mb-8 xl:mb-[68px]">
                      0{index + 1}
                    </p>
                    <div className="px-0 lg:px-6 py-2 lg:py-4">
                      <h2 className="mb-3 md:mb-4 text-xl md:text-3xl xl:text-4xl text-white font-bold">
                        {item.name}
                      </h2>
                      <p className="text-base md:text-xl xl:text-2xl text-[#9F9F9F]">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>

                {/* <img
                  src="/images/bg-service.png"
                  alt=""
                  className="absolute top-2 right-0 translate-x-[50%] h-[300px] md:h-[400px] xl:h-[560px] max-w-[650px] object-cover hidden lg:block opacity-30 xl:opacity-100"
                /> */}
              </div>
            );
          }

          return (
            <div id={item.slug} className="bg-white">
              <div className="container py-12 md:py-20 xl:!py-[150px] flex flex-col-reverse lg:flex-row gap-6 md:gap-12 xl:gap-[107px] items-center lg:items-end px-4 xl:px-0">
                <div data-aos="fade-right">
                  <p className="italic text-6xl md:text-[120px] xl:text-[200px] font-[900] text-[#ced1dd] leading-none mb-4 md:mb-8 xl:mb-[68px]">
                    0{index + 1}
                  </p>
                  <div className="px-0 lg:px-6 py-2 lg:py-4">
                    <h2 className="mb-3 md:mb-4 text-xl md:text-3xl xl:text-4xl text-[#303133] font-bold">
                      {item.name}
                    </h2>
                    <p className="text-base md:text-xl xl:text-2xl text-[#606266]">
                      {item.description}
                    </p>
                  </div>
                </div>

                <div
                  className="w-full lg:w-auto lg:flex-shrink-0"
                  data-aos="fade-left"
                >
                  <img
                    src={item.thumbnail}
                    alt={item.name}
                    className="w-full h-[250px] md:h-[400px] xl:h-[560px] max-w-[650px] object-cover !rounded-lg lg:rounded-none"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* <div className="bg-[url('/images/test/anhnen.jpg')] relative bg-center bg-cover bg-no-repeat w-full overflow-hidden">
        <div className="bg-[#051641CC] flex flex-col justify-center items-center py-10 md:py-[100px] px-4">
          <div className="container relative z-0 overflow-hidden flex flex-col items-center gap-y-6 md:gap-y-16">
            <div data-aos="fade-up" className="text-center">
              <h2 className="text-2xl md:text-4xl xl:text-6xl font-semibold text-white">
                Sẵn sàng bắt đầu dự án của bạn?
              </h2>
              <p className="text-base md:text-lg xl:text-xl text-[#D1D5DC] mt-4 md:mt-[23px] max-w-2xl mx-auto">
                Liên hệ với chúng tôi ngay hôm nay để nhận tư vấn miễn phí từ
                đội ngũ chuyên gia
              </p>
              <div className="mt-6 md:mt-[33px] flex flex-col sm:flex-row gap-4 mx-auto justify-center">
                <Link href={`/lien-he#tu-van`}>
                  <Button
                    size="large"
                    shape="round"
                    type="primary"
                    className="!py-3 md:!py-4 !px-6 md:!px-10 !h-[44px] md:!h-[50px] !text-white !font-medium !text-sm md:!text-base"
                  >
                    Nhận tư vấn ngay
                  </Button>
                </Link>
                <a href={`tel:${aboutUs?.soDienThoai}`}>
                  <Button
                    size="large"
                    shape="round"
                    ghost
                    className="!py-3 md:!py-4 !px-6 md:!px-10 !h-[44px] md:!h-[50px] !text-white !font-medium !border-[2px] !text-sm md:!text-base"
                  >
                    Gọi: {aboutUs?.soDienThoai || ""}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default ServiceIndex;
